<!-- Created by Maxim B. on 01/04/20.-->
<!-- Copyright © 2020 Curriculum Ltd. All rights reserved.-->

<mat-form-field
  [formGroup]="formGroup"
  color="primary"
  fxFlexFill
  [ngClass]="[
    isGreyBackground ? 'add-grey-background' : '',
    formGroup.controls[controlName].value?.toString().length ? 'not-empty-inp' : 'empty-inp'
  ]"
  [appearance]="isBordered ? 'outline' : 'standard'">
    <mat-label *ngIf="placeholder">{{ placeholder }}</mat-label>
    <input
      matInput
      aria-label="default time"
      [ngxTimepicker]="defaultValue"
      [readonly]="isReadOnly"
      #customInput
      [class.centered]="isCentered"
      [formControlName]="controlName"
      (keyup)="updateValue()"
      (blur)="onLostFocus()"
    />
    <ngx-material-timepicker
      (timeSet)="changeValue($event)"
      #defaultValue
      [confirmBtnTmpl]="confirmButton"
      [cancelBtnTmpl]="cancelButton">
    </ngx-material-timepicker>

  <ng-template #cancelButton>
    <curr-button
      class="m-r-16"
      type="button"
      fxFlexAlign="center"
      variant="text"
      size="big">
      {{ 'shared.confirmPopup.cancel' | translate }}
    </curr-button>
  </ng-template>

    <ng-template #confirmButton>
      <curr-button
        type="button"
        fxFlexAlign="center"
        variant="contained"
        size="big">
        {{ 'shared.confirmPopup.confirm' | translate }}
      </curr-button>
    </ng-template>

  <ngx-material-timepicker-toggle *ngIf="suffix" [for]="defaultValue" matSuffix class="input-suffix">
    <mat-icon [svgIcon]="suffix"></mat-icon>
  </ngx-material-timepicker-toggle>

  <mat-hint *ngIf="userHint">{{ userHint }}</mat-hint>
  <mat-error *ngIf="formGroup.controls[controlName]?.errors">{{ errorMessage }}</mat-error>
</mat-form-field>
